const resolveHostname = (hostname: string): string | undefined => {
  const {
    VITE_ACCOUNT_HOSTNAME: accountHostname,
    VITE_PRODUCT_PAGES_HOSTNAME: productPagesHostname,
    VITE_LEGACY_SHOP_HOSTNAME: legacyShopHostname,
    VITE_SITE_PAGES_HOSTNAME: sitePagesHostname,
    VITE_COPRODUCER_HOSTNAME: coproducerHostname,
    VITE_BLOG_HOSTNAME: blogHostname
  } = import.meta.env

  const hostnamesMap: Record<string, string> = {
    accountHostname,
    productPagesHostname,
    legacyShopHostname,
    sitePagesHostname,
    coproducerHostname,
    blogHostname
  }

  return hostnamesMap[hostname]
}

export default resolveHostname
